import { SeverityResult } from "domain/entities/severity";
import { SeverityRepository } from "domain/repositories";

export default class GetAllUseCase {
    private severityRepository: SeverityRepository;
    
    public constructor(severityRepository: SeverityRepository) {
        this.severityRepository = severityRepository
    }

    public async getAllSeverities(token: Promise<[string | null, string | null]>): Promise<[SeverityResult[], null] | [null, Error]> {
        const [t, ] = await token;
        if (t !== null) {
            return this.severityRepository.getAllSeverities(t);
        } else {
            return [null, new Error("Autenticación faltante")];
        }
    }
}